export const forbidenTagsForEditors = {
	FORBID_TAGS: ['img', 'script', 'iframe', 'embed', 'object', 'svg', 'meta', 'video', 'audio'],
}
